<template>
  <div class='centered' v-if="survey?.status == 'SENT' ">
    <form id="app" @submit="checkForm" method="post">
      <!-- <div id="#part_one" style="visibility: hidden;display: none;"> -->

      <p v-if="errors.length">
        <b>Please correct the following error(s):</b>
      <ul>
        <li v-for="error in errors">{{ error }}</li>
      </ul>
      </p>

      <div id="#part_one" v-if="show_me">
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>1 - Qualité de l'information</legend>
          <p>
            <label for="q1_1_1">Sur la formation</label>
            <select id="q1_1_1" v-model="q1_1_1" name="q1_1_1">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>

          <p>
            <label for="q1_1_2">Sur les modalités d’inscription</label>
            <select id="q1_1_2" v-model="q1_1_2" name="q1_1_2">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>2 - Qualité de la formation</legend>
          <p>
            <label for="q1_2_1">Les contenus</label>
            <select id="q1_2_1" v-model="q1_2_1" name="q1_2_1">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_2_2">Les outils mobilisés</label>
            <select id="q1_2_2" v-model="q1_2_2" name="q1_2_2">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_2_3">Les méthodes pédagogiques</label>
            <select id="q1_2_3" v-model="q1_2_3" name="q1_2_3">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_2_4">Les réponses apportées par l’équipe pédagogique</label>
            <select id="q1_2_4" v-model="q1_2_4" name="q1_2_4">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_2_5">Les intervenants (qualité et diversité)</label>
            <select id="q1_2_5" v-model="q1_2_5" name="q1_2_5">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>3 - Qualité du suivi</legend>
          <p>
            <label for="q1_3_1">Suivi pédagogique en centre (Entretien – bilan) </label>
            <select id="q1_3_1" v-model="q1_3_1" name="q1_3_1">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_3_2">Suivi pédagogique en structure (Visite – livret de suivi )</label>
            <select id="q1_3_2" v-model="q1_3_2" name="q1_3_2">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_3_3">Accompagnement du Maître d’Apprentissage en structure</label>
            <select id="q1_3_3" v-model="q1_3_3" name="q1_3_3">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_3_4">Accompagnement individuel en cas de difficulté</label>
            <select id="q1_3_4" v-model="q1_3_4" name="q1_3_4">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_3_5">Préparation à l’insertion professionnelle (CV, lettre de motivation)</label>
            <select id="q1_3_5" v-model="q1_3_5" name="q1_3_5">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>4 - Qualité de l’accueil</legend>
          <p>
            <label for="q1_4_1">Les infrastructures (salles, espaces sportifs,…)</label>
            <select id="q1_4_1" v-model="q1_4_1" name="q1_4_1">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_4_2">Le matériel mis à disposition</label>
            <select id="q1_4_2" v-model="q1_4_2" name="q1_4_2">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_4_3">Les horaires</label>
            <select id="q1_4_3" v-model="q1_4_3" name="q1_4_3">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_4_4">La disponibilité et les compétences du personnel</label>
            <select id="q1_4_4" v-model="q1_4_4" name="q1_4_4">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>5 - Organisation de la formation</legend>
          <p>
            <label for="q1_5_1">Le rythme de la formation (alternance centre et structure)</label>
            <select id="q1_5_1" v-model="q1_5_1" name="q1_5_1">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
          <p>
            <label for="q1_5_2">La durée de la formation</label>
            <select id="q1_5_2" v-model="q1_5_2" name="q1_5_2">
              <option disabled value="">Choisissez un valeur</option>
              <option>Très satisfaisant</option>
              <option>Satisfaisant</option>
              <option>Tout juste satisfaisant</option>
              <option>Insatisfaisant</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>6 - Recommandations</legend>
          <p>
            <label for="q1_6_1">La formation a-t-elle répondu à vos attentes ?</label>
            <select id="q1_6_1" v-model="q1_6_1" name="q1_6_1">
              <option>Oui</option>
              <option>Non</option>
            </select>
          </p>
          <p>
            <label for="q1_6_2">Recommanderiez vous cette formation ?</label>
            <select id="q1_6_2" v-model="q1_6_2" name="q1_6_2">
              <option>Oui</option>
              <option>Non</option>
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <button @click="toogle"> Suivant &gt;&gt;</button>
        <br>
        <br>

      </div>
      <div id="#part_two" v-if="!show_me">
        <!--------------------------------------------------------------------------------------------------------------->
        <br>
        <fieldset>
          <legend>1 - Sortie</legend>
          <p>
            <!-- ATTENTION si modification dans la liste ci-dessous, modifier aussi le script de récupération -->
            <label for="q2_1_1">Votre formation est terminée, quelle est désormais votre situation professionnelle
              ? </label>
            <select id="q2_1_1" v-model="q2_1_1" name="q2_1_1">
              <option>En emploi (contrat d'apprentissage ou pro inclus)</option>
              <!-- passage à la rubrique 2 - En emploi -->
              <option>En formation</option> <!--  passage à la rubrique 3 – En formation -->
              <option>En recherche d'emploi</option> <!--  passage à la rubrique 4 - Recherche d’emploi -->
              <option>Immersion à l'étranger</option> <!--  passage à la rubrique 5 - Immersion à l’étranger -->
              <option>Autres</option> <!-- passage à la rubrique 6 - Autres -->
            </select>
          </p>
        </fieldset>
        <br>
        <!--------------------------------------------------------------------------------------------------------------->
        <div v-if="q2_1_1 === 'En emploi (contrat d\'apprentissage ou pro inclus)'">
          <br>
          <fieldset>
            <legend>2 - Emploi</legend>
            <p>
              <label for="q2_2_1">Votre activité professionnelle est-elle en lien avec la formation suivie ? </label>
              <select id="q2_2_1" v-model="q2_2_1" name="q2_2_1">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
            <p>
              <label for="q2_2_2">Votre activité est-elle réalisée en partie ou en totalité chez votre dernier employeur
                ? </label>
              <select id="q2_2_2" v-model="q2_2_2" name="q2_2_2">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
            <p>
              <label for="q2_2_3">Dans quelle région exercez-vous votre activité ? </label>
              <select id="q2_2_3" v-model="q2_2_3" name="q2_2_3">
                <option>Auvergne Rhône-Alpes</option>
                <option>Provence Alpes Côte d’Azur</option>
                <option>Autres régions</option> <!-- précisez : …………………… -->
                <option>A l’étranger</option> <!-- précisez : ……………………… -->
              </select>
            </p>
            <p v-if="[ 'Autres régions', 'A l’étranger' ].includes(q2_2_3)">
              <label>Précisez :</label>
              <input id="q2_2_3_1" v-model="q2_2_3_1" name="q2_2_3_1" type="text">
            </p>
            <p>
              <!-- ATTENTION si modification dans la liste ci-dessous, modifier aussi le script de récupération -->
              <label for="q2_2_4">Sous quel type de contrat êtes-vous ? </label>
              <select id="q2_2_4" v-model="q2_2_4" name="q2_2_4">
                <option>CDD - temps plein + de 6 mois</option>
                <option>CDD - temps plein - de 6 mois</option>
                <option>CDD - temps partiel + de 6 mois</option>
                <option>CDD - temps partiel - de 6 mois</option>
                <option>CDI - temps plein</option>
                <option>CDI - temps partiel</option>
                <option>Contrat saisonnier</option>
                <option>Contrat aidé</option>
                <option>Missions d'intérim</option>
                <option>Indépendant ou création d'entreprise - Micro-entreprise</option>
                <option>Indépendant ou création d'entreprise - Société ou entreprise</option>
                <option>En contrat d'apprentissage - Même niveau de diplôme</option>
                <option>En contrat d'apprentissage - Niveau de diplôme supérieur</option>
                <option>En contrat de professionnalisation - Même niveau de diplôme</option>
                <option>En contrat de professionnalisation - Niveau de diplôme supérieur</option>
              </select>
            </p>
            <p>
              <label for="q2_2_5">Cumulez-vous plusieurs contrats ou statuts ?</label>
              <select id="q2_2_5" v-model="q2_2_5" name="q2_2_5">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
            <p>
              <label for="q2_2_6">Si vous êtes à temps partiel, êtes-vous à la recherche d’un complément d’activités
                ? </label>
              <select id="q2_2_6" v-model="q2_2_6" name="q2_2_6">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
          </fieldset>
          <br>
        </div>
        <!--------------------------------------------------------------------------------------------------------------->
        <div v-if="q2_1_1 === 'En formation'">
          <br>
          <fieldset>
            <legend>3 - En formation</legend>
            <p>
              <!-- ATTENTION si modification dans la liste ci-dessous, modifier aussi le script de récupération -->
              <label for="q2_3_1">Vers quel niveau de diplôme ?</label>
              <select id="q2_3_1" v-model="q2_3_1" name="q2_3_1">
                <option>Même niveau de diplôme</option>
                <option>Niveau de diplôme supérieur</option>
              </select>
            </p>
            <p>
              <label for="q2_3_2">Dans quel secteur d’activités ?</label>
              <select id="q2_3_2" v-model="q2_3_2" name="q2_3_2">
                <option>Sport</option>
                <option>Animation</option>
                <option>Tourisme</option>
                <option>ESports</option>
                <option>Autre</option> <!-- précisez : ……………………… -->
              </select>
            </p>
            <p v-if="[ 'Autre' ].includes(q2_3_2)">
              <label>précisez :</label>
              <input id="q2_3_2_1" v-model="q2_3_2_1" name="q2_3_2_1" type="text">
            </p>
          </fieldset>
          <br>
        </div>
        <!--------------------------------------------------------------------------------------------------------------->
        <div v-if="q2_1_1 === 'En recherche d\'emploi'">
          <br>
          <fieldset>
            <legend>4 - A la recherche d’un emploi</legend>
            <p>
              <label for="q2_4_1">Votre recherche d’emploi est-elle en lien avec la formation suivie ?</label>
              <select id="q2_4_1" v-model="q2_4_1" name="q2_4_1">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
            <p>
              <label for="q2_4_2">Dans quelle région recherchez-vous un emploi ?</label>
              <select id="q2_4_2" v-model="q2_4_2" name="q2_4_2">
                <option>Auvergne Rhône-Alpes</option>
                <option>Provence Alpes Côte d’Azur</option>
                <option>Autres régions</option> <!-- précisez : …………………… -->
                <option>A l’étranger</option> <!-- précisez : ……………………… -->
              </select>
            </p>
            <p v-if="[ 'Autres régions', 'A l’étranger' ].includes(q2_4_2)">
              <label>précisez :</label>
              <input id="q2_4_2_1" v-model="q2_4_2_1" name="q2_4_2_1" type="text">
            </p>

            <p>
              <!-- ATTENTION si modification dans la liste ci-dessous, modifier aussi le script de récupération -->
              <label for="q2_4_3">Dans l’idéal, quel contrat ou statut recherchez-vous ?</label>
              <select id="q2_4_3" v-model="q2_4_3" name="q2_4_3">
                <option>CDD - temps plein + de 6 mois</option>
                <option>CDD - temps plein - de 6 mois</option>
                <option>CDD - temps partiel + de 6 mois</option>
                <option>CDD - temps partiel - de 6 mois</option>
                <option>CDI - temps plein</option>
                <option>CDI - temps partiel</option>
                <option>Contrat saisonnier</option>
                <option>Contrat aidé</option>
                <option>Missions d'intérim</option>
                <option>Indépendant ou création d'entreprise - Micro-entreprise</option>
                <option>Indépendant ou création d'entreprise - Société ou entreprise</option>
                <option>En contrat d'apprentissage - Même niveau de diplôme</option>
                <option>En contrat d'apprentissage - Niveau de diplôme supérieur</option>
                <option>En contrat de professionnalisation - Même niveau de diplôme</option>
                <option>En contrat de professionnalisation - Niveau de diplôme supérieur</option>
              </select>
            </p>
            <p>
              <label for="q2_4_4">Souhaitez-vous bénéficier d’un accès aux réseaux des institutions susceptibles de vous
                aider dans le cadre de votre recherche d’emploi ?</label>
              <select id="q2_4_4" v-model="q2_4_4" name="q2_4_4">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
            <p>
              <label for="q2_4_5">Souhaitez-vous accéder aux offres d’emploi du réseau de votre CFA ?</label>
              <select id="q2_4_5" v-model="q2_4_5" name="q2_4_5">
                <option>Oui</option>
                <option>Non</option>
              </select>
            </p>
          </fieldset>
          <br>
        </div>
        <!--------------------------------------------------------------------------------------------------------------->
        <div v-if="q2_1_1 === 'Immersion à l\'étranger'">
          <br>
          <fieldset>
            <legend>5 - Immersion à l’étranger</legend>
            <p>
              <!-- ATTENTION si modification dans la liste ci-dessous, modifier aussi le script de récupération -->
              <label for="q2_5_1">Combien de temps partez-vous à l’étranger ?</label>
              <select id="q2_5_1" v-model="q2_5_1" name="q2_5_1">
                <option>Moins de 3 mois</option>
                <option>Entre 3 et 6 mois</option>
                <option>Plus de 6 mois</option>
                <option>De manière définitive</option>
              </select>
            </p>
            <p>
              <label for="q2_5_2">Dans quelle région du monde ?</label>
              <select id="q2_5_2" v-model="q2_5_2" name="q2_5_2">
                <option>Pays européens</option>
                <option>Amériques</option>
                <option>Asie</option>
                <option>Afrique</option>
                <option>Autre</option>
              </select>
            </p>
            <p>
              <label>Dans quel pays ? </label>
              <input id="q2_5_3" v-model="q2_5_3" name="q2_5_3" type="text">
            </p>
          </fieldset>
          <br>
        </div>
        <!--------------------------------------------------------------------------------------------------------------->
        <div v-if="q2_1_1 === 'Autres'">
          <br>
          <fieldset>
            <legend>6 - Autre</legend>
            <p>
              <label for="q2_6_1">Autre situation</label>
              <textarea id="q2_6_1" v-model="q2_6_1" name="q2_6_1"></textarea>
            </p>
          </fieldset>
          <br>
        </div>

        <button @click="toogle"> &lt;&lt; Précédent</button>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <button type="submit">Terminer</button>
        <br>
      </div>
    </form>
  </div>
  <div class="centered" v-else>
    <h4>
      Le questionnaire à déjà été rempli ou n'est plus disponible, merci de votre participation !
    </h4>
  </div>

</template>
<!-- https://localhost:8444/survey/form/12356 -->
<script>

import {useRoute} from 'vue-router'
import ApiService from "../../services/api.service";

export default {
  name: "Form",
  el: '#app',
  setup() {
    const list_part_1 = [
      'q1_1_1', 'q1_1_2',
      'q1_2_1', 'q1_2_2', 'q1_2_3', 'q1_2_4', 'q1_2_5',
      'q1_3_1', 'q1_3_2', 'q1_3_3', 'q1_3_4', 'q1_3_5',
      'q1_4_1', 'q1_4_2', 'q1_4_3', 'q1_4_4',
      'q1_5_1', 'q1_5_2',
      'q1_6_1', 'q1_6_2'
    ];
    const list_part_2 = [
      'q2_1_1',
      'q2_2_1', 'q2_2_2', 'q2_2_3', 'q2_2_3_1', 'q2_2_4', 'q2_2_5', 'q2_2_6',
      'q2_3_1', 'q2_3_2', 'q2_3_2_1',
      'q2_4_1', 'q2_4_2', 'q2_4_2_1', 'q2_4_3', 'q2_4_4', 'q2_4_5',
      'q2_5_1', 'q2_5_2', 'q2_5_3',
      'q2_6_1'
    ];
  },
  data() {
    return {
      survey_html_status: null,
      survey: null,
      params_id: null,
      show_me: true,
      errors: [],
      q1_1_1: null,
      q1_1_2: null,
      q1_2_1: null,
      q1_2_2: null,
      q1_2_3: null,
      q1_2_4: null,
      q1_2_5: null,
      q1_3_1: null,
      q1_3_2: null,
      q1_3_3: null,
      q1_3_4: null,
      q1_3_5: null,
      q1_4_1: null,
      q1_4_2: null,
      q1_4_3: null,
      q1_4_4: null,
      q1_5_1: null,
      q1_5_2: null,
      q1_6_1: null,
      q1_6_2: null,
      q2_1_1: null,
      q2_2_1: null,
      q2_2_2: null,
      q2_2_3: null,
      q2_2_3_1: null,
      q2_2_4: null,
      q2_2_5: null,
      q2_2_6: null,
      q2_3_1: null,
      q2_3_2: null,
      q2_3_2_1: null,
      q2_4_1: null,
      q2_4_2: null,
      q2_4_3: null,
      q2_4_4: null,
      q2_4_5: null,
      q2_4_2_1: null,
      q2_5_1: null,
      q2_5_2: null,
      q2_5_3: null,
      q2_6_1: null,
    }
  },
  computed: {
    getAnsweredAt: function () {
      const todayFullDate = new Date()
      const today = todayFullDate.toISOString().split('T')[0]
      const todayHours = todayFullDate.toISOString().split('T')[1].split('.')
      return today + ' ' + todayHours[0]
    },
  },
  methods: {
    convertStringToInteger: function (string) {
      if (string.includes("Très satisfaisant")) {
        return 4;
      } else if (string.includes("Satisfaisant")) {
        return 3;
      } else if (string.includes("Tout juste satisfaisant")) {
        return 2;
      } else if (string.includes("Insatisfaisant")) {
        return 1;
      } else {
        return null;
      }
    },
    convertStringToBoleanInteger: function (string) {
      if (string.includes("Oui")) {
        return 1;
      } else if (string.includes("Non")) {
        return 0;
      } else {
        return null;
      }
    },
    getSituationStringToInteger: function (string) {
      if (string.includes("En emploi")) {
        return 2;
      } else if (string.includes("En formation")) {
        return 3;
      } else if (string.includes("En recherche")) {
        return 4;
      } else if (string.includes("Immersion")) {
        return 5;
      } else if (string.includes("Autres")) {
        return 6;
      } else {
        return null;
      }
    },
    getContractTypeStringToInteger: function (string) {
      switch (true) {
        case ["CDD - temps partiel - de 6 mois"].includes(string):
          return 1;
        case ["CDD - temps partiel + de 6 mois"].includes(string):
          return 2;
        case ["CDD - temps plein - de 6 mois"].includes(string):
          return 3;
        case ["CDD - temps plein + de 6 mois"].includes(string):
          return 4;
        case ["CDI - temps partiel"].includes(string):
          return 5;
        case ["CDI - temps plein"].includes(string):
          return 6;
        case ["Contrat saisonnier"].includes(string):
          return 7;
        case ["Contrat aidé"].includes(string):
          return 8;
        case ["Missions d'intérim"].includes(string):
          return 9;
        case ["Indépendant ou création d'entreprise - Micro-entreprise"].includes(string):
          return 10;
        case ["Indépendant ou création d'entreprise - Société ou entreprise"].includes(string):
          return 11;
        case ["En contrat d'apprentissage - Même niveau de diplôme"].includes(string):
          return 12;
        case ["En contrat d'apprentissage - Niveau de diplôme supérieur"].includes(string):
          return 13;
        case ["En contrat de professionnalisation - Même niveau de diplôme"].includes(string):
          return 14;
        case ["En contrat de professionnalisation - Niveau de diplôme supérieur"].includes(string):
          return 15;
        default:
          return null;
      }
    },
    getDegreeLevelStringToInteger: function (string) {
      if (string.includes("Même niveau de diplôme")) {
        return 1;
      } else if(string.includes("Niveau de diplôme supérieur")) {
        return 2;
      } else {
        return null;
      }
    },
    getTimeAbroadStringToInteger: function (string) {
      switch (true) {
        case ["Moins de 3 mois"].includes(string):
          return 1;
        case ["Entre 3 et 6 mois"].includes(string):
          return 2;
        case ["Plus de 6 mois"].includes(string):
          return 3;
        case ["De manière définitive"].includes(string):
          return 4;
        default:
          return null;
      }
    },
    toogle: function () {
      this.show_me = !this.show_me;
      window.scrollTo(0, 0);
    },
    checkForm: function (e) {
      let posted_data = JSON.parse(JSON.stringify(this.$data));

      delete posted_data['survey_html_status'];
      delete posted_data['survey'];
      delete posted_data['params_id'];
      delete posted_data['show_me'];
      delete posted_data['errors'];

      const formData = {
        posted_data: posted_data,
        answered_at: new Date().toISOString(),
        status: 'ANSWERED'
      }

      if (this.studentSurvey.length > 0) {
        const survey_data = {
          information_formation: this.convertStringToInteger(this.$data.q1_1_1),
          information_modalites_inscription: this.convertStringToInteger(this.$data.q1_1_2),
          formation_contenus: this.convertStringToInteger(this.$data.q1_2_1),
          formation_outils_mobilises: this.convertStringToInteger(this.$data.q1_2_2),
          formation_methodes_pedagogiques: this.convertStringToInteger(this.$data.q1_2_3),
          formation_reponses_apportees_equipe_peda: this.convertStringToInteger(this.$data.q1_2_4),
          formation_intervenants: this.convertStringToInteger(this.$data.q1_2_5),
          suivi_pedagogique_centre: this.convertStringToInteger(this.$data.q1_3_1),
          suivi_pedagogique_structure: this.convertStringToInteger(this.$data.q1_3_2),
          suivi_accompagnement_ma_structure: this.convertStringToInteger(this.$data.q1_3_3),
          suivi_accompagnement_individuel: this.convertStringToInteger(this.$data.q1_3_4),
          suivi_prepa_insertion_pro: this.convertStringToInteger(this.$data.q1_3_5),
          accueil_infrastructures: this.convertStringToInteger(this.$data.q1_4_1),
          accueil_materiel: this.convertStringToInteger(this.$data.q1_4_2),
          accueil_horaires: this.convertStringToInteger(this.$data.q1_4_3),
          accueil_disponibilites_et_competences: this.convertStringToInteger(this.$data.q1_4_4),
          formation_rythme: this.convertStringToInteger(this.$data.q1_5_1),
          formation_duree: this.convertStringToInteger(this.$data.q1_5_2),
          formation_reponse_attentes: this.convertStringToBoleanInteger(this.$data.q1_6_1),
          formation_recommandation: this.convertStringToBoleanInteger(this.$data.q1_6_2),
          answered_at: this.getAnsweredAt,
          status: 2
        }

        ApiService.putRequest('/etudiant_enquete_satisfactions/' + this.studentSurvey[0].id, survey_data).then(response_enquete => {
        })
      }

      if (this.studentQuizz.length > 0) {
        let quizz_data = {
          situation: this.getSituationStringToInteger(this.$data.q2_1_1),
          answered_at: this.getAnsweredAt,
          status: 2
        }
        if (this.$data.q2_6_1 && this.$data.q2_6_1 != '') {
          quizz_data.situation_autre = this.$data.q2_6_1
        }
        ApiService.putRequest('/etudiant_questionnaire_insertions/' + this.studentQuizz[0].id, quizz_data).then(response_questionnaire => {
          if (quizz_data.situation == 2) {
            let job_area = '';
            if ([ 'Autres régions', 'A l’étranger' ].includes(this.$data.q2_2_3)) {
              job_area = this.$data.q2_2_3_1
            } else {
              job_area = this.$data.q2_2_3
            }
            const quizz_emploi_data = {
              questionnaire_insertion: this.studentQuizz[0]['@id'],
              job_related_to_training: this.convertStringToBoleanInteger(this.$data.q2_2_1),
              employment_with_last_employer: this.convertStringToBoleanInteger(this.$data.q2_2_2),
              job_area: job_area,
              type_of_contract: this.getContractTypeStringToInteger(this.$data.q2_2_4),
              multiple_employment: this.convertStringToBoleanInteger(this.$data.q2_2_5),
              looking_for_additional_activities: this.convertStringToBoleanInteger(this.$data.q2_2_6)
            }

            ApiService.postRequest('/etudiant_questionnaire_insertion_emplois', quizz_emploi_data).then(response_questionnaire_insertion_emploi => {
            })
          }

          if (quizz_data.situation == 3) {
            let branch_of_activity = '';
            if ([ 'Autre' ].includes(this.$data.q2_3_2_1)) {
              branch_of_activity = this.$data.q2_3_2_1
            } else {
              branch_of_activity = this.$data.q2_3_2
            }
            const quizz_formation_data = {
              questionnaire_insertion: this.studentQuizz[0]['@id'],
              degree_level: this.getDegreeLevelStringToInteger(this.$data.q2_3_1),
              branch_of_activity: branch_of_activity
            }

            ApiService.postRequest('/etudiant_questionnaire_insertion_formations', quizz_formation_data).then(response_questionnaire_insertion_formation => {
            })
          }

          if (quizz_data.situation == 4) {
            let job_search_area = '';
            if ([ 'Autres régions', 'A l’étranger' ].includes(this.$data.q2_4_2)) {
              job_search_area = this.$data.q2_4_2_1
            } else {
              job_search_area = this.$data.q2_4_2
            }
            const quizz_recherche_emploi_data = {
              questionnaire_insertion: this.studentQuizz[0]['@id'],
              job_search_related_to_training: this.convertStringToBoleanInteger(this.$data.q2_4_1),
              job_search_area: job_search_area,
              type_of_contract_sought: this.getContractTypeStringToInteger(this.$data.q2_4_3),
              authorized_access_institutional_networks: this.convertStringToBoleanInteger(this.$data.q2_4_4),
              access_job_offers_authorized_cfa_network: this.convertStringToBoleanInteger(this.$data.q2_4_5)
            }

            ApiService.postRequest('/etudiant_questionnaire_insertion_recherche_emplois', quizz_recherche_emploi_data).then(response_questionnaire_insertion_recherche => {
            })
          }

          if (quizz_data.situation == 5) {
            const quizz_immersion_data = {
              questionnaire_insertion: this.studentQuizz[0]['@id'],
              time_abroad: this.getTimeAbroadStringToInteger(this.$data.q2_5_1),
              job_area: this.$data.q2_5_2,
              country_area: this.$data.q2_5_3,
            }

            ApiService.postRequest('/etudiant_questionnaire_insertion_immersion_etrangers', quizz_immersion_data).then(response_questionnaire_insertion_immersion => {})
          }
        })
      }

      ApiService.putRequest(this.survey['@id'].substring(1), formData).then(response => {
        window.close();
      }).catch(() => {
        this.$displayError()
      })

      e.preventDefault();
    }
  },
  mounted() {
    const route = useRoute();
    this.params_id = route.params.id;

    ApiService.getRequest('survey_mailers/' + route.params.id).then(result => {
      this.survey_html_status = result.status;
      this.survey = result.data
      ApiService.getRequest('/etudiant_enquete_satisfactions?etudiant=' + result.data.etudiant_id).then(enquete => {
        this.studentSurvey = enquete.data['hydra:member']
      })
      ApiService.getRequest('/etudiant_questionnaire_insertions?etudiant=' + result.data.etudiant_id).then(questionnaire => {
        this.studentQuizz = questionnaire.data['hydra:member']
      })
    }).catch(function (error) {
      this.survey_html_status = error.status;
      this.survey = null;
    });
  }

}
</script>

<style scoped>

.centered {
  width: 50%;
  padding-top: 2em;
  margin: auto;
}

label {
  margin-top: 10px;
  display: inline-block;
  width: 50%;
}

select {
  width: 50%;
  height: 30px;
  border: 1px solid #999;
  font-size: 18px;
  border-radius: 5px;
}

input[type=text] {
  width: 50%;
  height: 30px;
  border: 1px solid #999;
  font-size: 18px;
  border-radius: 5px;
}

select option {
  padding-top: 3px;
}

textarea {
  display: block;
  width: 100%;
  height: 180px;
}
</style>
